module.exports = __webpack_public_path__ + "img/icomoon.010c8e03.svg";